export var REQUIRED_MESSAGE = { message: "forms.errors.rules.required" };
export var CITY_RANGE_LENGTH = { message: "forms.errors.city.range_length" };
export var CITY_INVALID = { message: "forms.errors.city.invalid_schema" };
export var EMAIL_INVALID = { message: "forms.errors.email.invalid_chars" };
export var ADDRESS_LINE1_INVALID = {
    message: "forms.errors.addr_line1.invalid_schema",
};
export var ADDRESS_LINE2_INVALID = {
    message: "forms.errors.addr_line2.invalid_schema",
};
export var MAX_ANNUAL_INCOME = {
    message: "forms.errors.income.invalid_length",
};
export var ANNUAL_INCOME_INVALID = {
    message: "forms.errors.income.invalid_schema",
};
export var ZIP_CODE_LENGTH = {
    message: "forms.errors.zipCode.char_length",
};
export var ZIP_CODE_INVALID = {
    message: "forms.errors.zipCode.invalid_schema",
};
export var PHONE_LENGTH = {
    message: "forms.errors.phone.required_length",
};
export var PHONE_INVALID = {
    message: "forms.errors.rules.phone",
};
